var DENIED_MESSAGES = [
    'Permission denied',
    'The request is not allowed by the user agent or the platform in the current context.',
];
// only Chrome seems to have a "dismissed" state where the user can try again
var DISMISSED_MESSAGES = ['Permission dismissed'];
var SYSTEM_PERMISSIONS_ERROR_NAMES = ['NotAllowedError', 'NotFoundError'];
export function isMediaDeniedError(error) {
    return DENIED_MESSAGES.some(function (message) { return error.message.includes(message); });
}
export function isMediaDismissedError(error) {
    return DISMISSED_MESSAGES.some(function (message) { return error.message.includes(message); });
}
export function isSystemPermissionsError(error) {
    return SYSTEM_PERMISSIONS_ERROR_NAMES.some(function (name) { return error.name === name; });
}
//# sourceMappingURL=mediaErrors.js.map